import React from 'react';

import { Chip } from '@mui/material';

import type { ApprovalRequestStatus } from '~/services/LuxLoyalty';

const STATUS_MAP: Record<ApprovalRequestStatus, { color: 'info' | 'warning' | 'success' | 'error'; label: string }> = {
  SUBMITTED: { color: 'info', label: 'Submitted' },
  PENDING: { color: 'warning', label: 'Pending' },
  APPROVED: { color: 'success', label: 'Approved' },
  REJECTED: { color: 'error', label: 'Rejected' },
};

interface ApprovalRequestStatusChipProps {
  status: ApprovalRequestStatus;
}

export default function ApprovalRequestStatusChip({ status }: ApprovalRequestStatusChipProps) {
  const { color, label } = STATUS_MAP[status];
  return <Chip label={label} color={color} size="small" />;
}
